import expandSectionsWithInvalidInputs from "./expandable-sections";

const DATASET = 'data-network-switching';
const datepickerSwitching = document.querySelector('[data-datepicker-switching]');
let calendarSwitching;
let isClicked = document.getElementById('isClicked');

const emptyDateSelect = (dateSelect) => {
    dateSelect.querySelectorAll('option').forEach(option =>
        option.value !== '' && option.remove()
    );
};

const setHidden = (node, hidden) => {
    const parentNode = node.hasAttribute(`${DATASET}-available-dates`) ?
        node.closest(`[${DATASET}-date]`) : node.parentElement;
    if (hidden) {
        node.setAttribute('hidden', 'hidden');
    } else {
        node.removeAttribute('hidden');
    }

    if (parentNode) {
        parentNode.setAttribute('data-has-hidden', hidden);
    }
};

const requestEndpoint = (url, method, body) => fetch(url, {
    method: method || 'GET',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
    },
    body: new URLSearchParams(body),
}).then(res => res.json());

const toggleDisabledAttr = (node, condition) => {
    node.disabled = !condition;
    node.parentElement.setAttribute('data-has-disabled', !condition);
};
const toggleReadOnly = (node, readOnly) => node.readOnly = readOnly;
const clearInputValue = node => node.value = '';
const clearValidClassAroundInput = (node) => {
    if (node.value != '') {
        return;
    }
    node.parentElement.classList.remove('is-valid');
};

const updateLabels = (networkSwitchingFieldset, selectedOptionValue) => {
    const form = networkSwitchingFieldset.closest(`[${DATASET}]`);
    form.dataset.networkSwitchingChoice = selectedOptionValue;
    if (selectedOptionValue === 'no') {
        return;
    }
    const phoneNumberInput = networkSwitchingFieldset
        .querySelector(`[${DATASET}-phone-number]`);
    const phoneNumberLabel = networkSwitchingFieldset
        .querySelector(`label[for=${phoneNumberInput.id}]`);
    const isPAC = selectedOptionValue === 'pac';
    const phoneNumberLabelSuffix = isPAC ? 'keep' : 'cancel';

    phoneNumberLabel.textContent = `Mobile number you wish to ${phoneNumberLabelSuffix}`;
};

const setFieldsetsStates = (
    networkSwitchingRadioInputs,
    networkSwitchingFieldset,
    networkSwitchingDateSelect,
    networkSwitchingToggleElement,
    event=null
) => {
    const checkedRadioInput = [...networkSwitchingRadioInputs]
        .find(radioInput => radioInput.checked);
    const form = networkSwitchingFieldset.closest(`[${DATASET}]`);
    const phoneNumber = form.querySelector(`[${DATASET}-phone-number]`);

    if (!checkedRadioInput) {
        return;
    }

	if (event) {
    	resetData(form);
	}
    networkSwitchingToggleElement.checked = true;
    checkedRadioInput.checked = true;
    checkedRadioInput
        .closest('.radio-selection-boolean')
        .classList.remove('is-invalid');

    const radioRelatedInputs = networkSwitchingFieldset
        .querySelectorAll(`[${DATASET}-type]`);
    const radioRelatedInput = networkSwitchingFieldset.querySelector(
        `[${DATASET}-type="${checkedRadioInput.value}"]`
    );

    toggleDisabledAttr(networkSwitchingFieldset, checkedRadioInput.value !== 'no');

    let enabledSelectDate = false;

    radioRelatedInputs.forEach((relatedInput) => {
        const isCurrentRadioRelatedInput = relatedInput === radioRelatedInput;
        toggleDisabledAttr(relatedInput, isCurrentRadioRelatedInput);
        clearValidClassAroundInput(relatedInput);
        clearValidClassAroundInput(phoneNumber);
        if (isCurrentRadioRelatedInput && relatedInput.value !== '') {
            if (networkSwitchingDateSelect.querySelectorAll('option').length > 1) {
                enabledSelectDate = true;
            }
        }
    });

    setFormState(form, enabledSelectDate ? 'edit' : 'validate');
    setHidden(networkSwitchingDateSelect.parentElement.parentElement, !enabledSelectDate);
    updateLabels(networkSwitchingFieldset, checkedRadioInput.value);
};

const updateFeedback = (form, formFeedback, message) => {
    setToggleOff(form);
    formFeedback.innerHTML = message;
    formFeedback.removeAttribute('hidden', 'hidden');
    form.parentElement.scrollIntoView(true);
};

const cloneForm = (form, submitConfirmation) => {
    let clone = document.createElement('form');
    let inputs = form.querySelectorAll(
        'input:not([data-non-submission-field]), select:not([data-non-submission-field])'
    );

    for (let i = 0; i < inputs.length; i++) {
        if (submitConfirmation && inputs[i].tagName == 'SELECT') {
            inputs[i].removeAttribute('form');
        }
        clone.appendChild(inputs[i].cloneNode(true));
    }

    if (submitConfirmation) {
        let input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'applyNetworkSwitchingConsent');
        input.setAttribute('value', '1');
        clone.appendChild(input);
    }

    return clone;
};

const setFormState = (form, state = 'validate') => {
    const submitButton = form.querySelector(`[${DATASET}-button]`);
    const editButton = form.querySelector(`[${DATASET}-edit-button]`);
    const inputs = form.querySelectorAll('input[type="text"]');
    const dateSelect = form.querySelector(`[${DATASET}-available-dates]`);

    setHidden(submitButton, state === 'edit');
    setHidden(editButton, state !== 'edit');
    setHidden(dateSelect, state !== 'edit');

    if (state === 'validate') {
        emptyDateSelect(dateSelect);
    }

    inputs.forEach((input) => {
        if (state === 'edit') {
            input.setAttribute('readonly', 'readonly');
        } else {
            input.removeAttribute('readonly');
        }
    });

    form.dataset.networkSwitchingFormState = state;
};

const submitForm = (networkSwitchingDateSelect) => {
    const form = document.querySelector(`[${DATASET}]`);
    const formFeedback = form.parentNode.querySelector(`[${DATASET}-feedback]`);
    const loader = document.querySelector('[data-loading-overlay]');
    const validateError = form.querySelector(`[${DATASET}-validate-error]`);
    isClicked.setAttribute('data-clicked', 'false');

    loader.dataset.activeTasks = 1;
    setHidden(validateError, true);

    formFeedback.setAttribute('hidden', 'hidden');

    requestEndpoint(
        form.getAttribute('data-action'),
        form.getAttribute('data-method'),
        new FormData(cloneForm(form))
    )
        .then((data) => {
            if (data.shouldReloadPage) {
                return window.location.reload();
            }
            if (data.result === 'success') {
                populateAvailableDates(data.availableDates, networkSwitchingDateSelect);
                setFormState(form, 'edit');
            } else {
                throw new Error(data.message);
            }
        })
        .catch((error) => {
            updateFeedback(form, formFeedback, error.message);
            setHidden(networkSwitchingDateSelect, true);
        })
        .finally(() => loader.dataset.activeTasks = 0);
};

const checkValidityOnBasketSubmit = (e, networkSwitchingForm) => {
    let input = document.querySelector('[data-network-switching-toggle]');
    if (input && input.checked !== true) {
        return;
    }

    const isValidateState = networkSwitchingForm.dataset.networkSwitchingFormState === 'validate';
    const validateErrorNode = networkSwitchingForm
        .querySelector(`[${DATASET}-validate-error]`);
    let invalidNode = null;

    if (networkSwitchingForm.dataset.networkSwitchingChoice === 'no') {
        return;
    }

    networkSwitchingForm
        .querySelectorAll('.form-group')
        .forEach((formGroup) => {
            let input = formGroup.querySelector('input');
            if (!input) {
                input = formGroup.querySelector('select');
            }
            if (!input) {
                return;
            }
            if (!input.checkValidity()) {
                formGroup.classList.add('is-invalid');
                invalidNode = invalidNode || formGroup;
            }
        });

    if (
        (!invalidNode || invalidNode && !!invalidNode.querySelector('[hidden]')) &&
        isValidateState
    ) {
        setHidden(validateErrorNode, false);
        invalidNode = validateErrorNode;
    }

    if (invalidNode) {
        e.stopPropagation();
        e.preventDefault();
        const labelHeight = 40,
            offset = (invalidNode.getBoundingClientRect().top + document.documentElement.scrollTop) - labelHeight;
        window.scrollTo(0, offset);
    }
    expandSectionsWithInvalidInputs();
};

const onValidateClick = (form, networkSwitchingDateSelect) => {
    const invalidInputs = [];
    const inputs = form.querySelectorAll('input');
    inputs.forEach((input) => {
        if (input.checkValidity()) {
            input.parentElement.classList.remove('is-invalid');
        } else {
            input.parentElement.classList.add('is-invalid');
            invalidInputs.push(input.dataset.analyticName || input.getAttribute('name'));
        }
    });
    if (invalidInputs.length == 0) {
        submitForm(networkSwitchingDateSelect);
    }
};

const checkoutNetworkSwitching = () => {
    const networkSwitchingForm = document.querySelector(`.checkout-network-switching[${DATASET}]`);
    
    if (!networkSwitchingForm) {
        return;
    }

    const basketFormButton = document
        .querySelector('#checkout-details-step-from button[type="submit"]');

    setNetworkSwitchingNotRequired(networkSwitchingForm);
    addPACSTACInfoIcons(networkSwitchingForm);

    const networkSwitchingToggleElement = networkSwitchingForm.querySelector(`[${DATASET}-toggle]`);
    networkSwitchingToggleElement.addEventListener('change', (e) => {
        resetForm(e, networkSwitchingForm);
        enableNetworkSwitchContent(e);
    });

    const networkSwitchingRadioInputs = networkSwitchingForm
        .querySelectorAll(`[${DATASET}-decision] input[type="radio"]`);
    const networkSwitchingFieldset = networkSwitchingForm
        .querySelector(`[${DATASET}-fieldset]`);
    const networkSwitchingDateSelect = networkSwitchingForm
        .querySelector(`[${DATASET}-available-dates]`);
    const networkSwitchingCancelButton = networkSwitchingForm
        .querySelector(`[${DATASET}-cancel]`);
    const networkSwitchingConfirmButton = networkSwitchingForm
        .querySelector(`[${DATASET}-button-confirm]`);
    const confirmDateError = networkSwitchingForm.querySelector('#confirm-btn-error');
    const networkSwitchingEditButton = networkSwitchingFieldset
        .querySelector(`[${DATASET}-edit-button]`);
    const codeInputs = networkSwitchingForm
        .querySelectorAll(`[${DATASET}-type]`);

    networkSwitchingCancelButton.addEventListener('click', (e) => {
        setToggleOff(networkSwitchingForm, e);
    });

    networkSwitchingRadioInputs.forEach((networkSwitchingRadioInput) => {
        networkSwitchingRadioInput.addEventListener('input', (e) => {
            setFieldsetsStates(
                networkSwitchingRadioInputs,
                networkSwitchingFieldset,
                networkSwitchingDateSelect,
                networkSwitchingToggleElement,
                e
            );
        });
    });

    bindAvailableDatesEvents(networkSwitchingDateSelect, networkSwitchingForm);
    bindSwitchingCheckEvents(networkSwitchingForm, networkSwitchingDateSelect);

    setFieldsetsStates(
        networkSwitchingRadioInputs,
        networkSwitchingFieldset,
        networkSwitchingDateSelect,
        networkSwitchingToggleElement
    );

    networkSwitchingForm
        .querySelector(`[${DATASET}-button]`)
        .addEventListener('click', () => onValidateClick(networkSwitchingForm, networkSwitchingDateSelect));

    if (networkSwitchingDateSelect.value !== '') {
        setHidden(networkSwitchingDateSelect, false);
    }

    networkSwitchingEditButton.addEventListener('click', () =>
        setFormState(networkSwitchingForm, 'validate')
    );
    codeInputs.forEach(input => input.addEventListener('keyup', () =>
        input.value = input.value.toUpperCase()
    ));

    const updateConfirmButtonState = () => {
        const hasDateSelected = !!networkSwitchingDateSelect.value;
        toggleDisabledAttr(networkSwitchingConfirmButton, hasDateSelected);
        if (confirmDateError) {
            setHidden(confirmDateError, hasDateSelected);
        }
    };

    // Ensure confirm is disabled until a date is selected.
    updateConfirmButtonState();

    networkSwitchingConfirmButton.addEventListener('click', function(e) {
        if (!networkSwitchingDateSelect.value) {
            if (confirmDateError) {
                setHidden(confirmDateError, false);
            }
            return;
        }
        submitConsent(e);
        isClicked.setAttribute('data-clicked', 'true');
    });

    if(basketFormButton){
        basketFormButton.addEventListener('click', e =>
            checkValidityOnBasketSubmit(e, networkSwitchingForm)
        );
    }
    
};

const populateAvailableDates = (availableDates, networkSwitchingDateSelect) => {
    let availableDatesValues = [];
    emptyDateSelect(networkSwitchingDateSelect);
    availableDates.map((availableDate) => {
        let option = document.createElement('option');
        option.value = availableDate.value;
        option.innerHTML = availableDate.label;
        networkSwitchingDateSelect.append(option);
    });
    networkSwitchingDateSelect.parentElement.parentElement.classList.remove('hidden');
    for (var i = 0; i < availableDates.length; i++) {
        availableDatesValues.push(availableDates[i].value);
    }
    createCalendar(availableDatesValues);
    datepickerSwitching.dataset.validate = true;
    setHidden(networkSwitchingDateSelect, false);
    setHidden(networkSwitchingDateSelect.parentElement.parentElement, false);
    networkSwitchingDateSelect.parentElement.parentElement.parentElement.querySelector(`[${DATASET}-confirm]`).classList.remove('hidden');
};

const enableNetworkSwitchContent = (event) => {
    const parentForm = event.target.closest(`[${DATASET}]`);
    const netSwitchingContent = parentForm.querySelector(`[${DATASET}-section]`);
    if (event.target.checked) {
        setHidden(netSwitchingContent, false);
        setNetworkSwitchingRequired(parentForm);
    } else {
        setHidden(netSwitchingContent, true);
        setNetworkSwitchingNotRequired(parentForm);
    }
};

const requestAvailableSwitchingDates = (event, networkSwitchingDateSelect) => {
    const form = event.target.closest(`[${DATASET}]`);
    const switchCode = form.querySelector(`[${DATASET}-type]:not([disabled])`);
    const phoneNumber = form.querySelector(`[${DATASET}-phone-number]`);

    if (switchCode.value == '' || phoneNumber.value == '') {
        return;
    }

    const formFeedback = form.parentNode.querySelector(`[${DATASET}-feedback]`);
    const loader = document.querySelector('[data-loading-overlay]');

    event.preventDefault();
    loader.dataset.activeTasks = 1;
    formFeedback.setAttribute('hidden', 'hidden');

    requestEndpoint(
        form.action,
        'POST',
        new FormData(cloneForm(form))
    )
        .then((data) => {
            if (data.result === 'success') {
                form.dataset.networkSwitchingDirty = 1;
                populateAvailableDates(data.availableDates, networkSwitchingDateSelect);
            } else {
                throw new Error(data.message);
            }
        })
        .catch(error => updateFeedback(form, formFeedback, error.message))
        .finally(() => loader.dataset.activeTasks = 0);
};

const bindAvailableDatesEvents = (networkSwitchingDateSelect, networkSwitchingForm) => {
    networkSwitchingDateSelect.addEventListener('change', () => {
        const selectedIndex = event.target.selectedIndex;
        const button = networkSwitchingForm.querySelector(`[${DATASET}-button]`);
        const confirm = networkSwitchingForm.querySelector(`[${DATASET}-confirm]`);
        const confirmButton = networkSwitchingForm.querySelector(`[${DATASET}-button-confirm]`);
        const confirmDateError = networkSwitchingForm.querySelector('#confirm-btn-error');
        const dateOptions = networkSwitchingForm.querySelector(`[${DATASET}-available-dates]`).querySelectorAll(':scope option');

        for (const element of dateOptions) {
            element.removeAttribute('selected');
        }

        event.target.options[selectedIndex].setAttribute('selected', 'selected');

        toggleDisabledAttr(button, event.target.value);
        setHidden(confirm, !event.target.value);
        if (confirmButton) {
            toggleDisabledAttr(confirmButton, event.target.value);
        }
        if (confirmDateError) {
            setHidden(confirmDateError, !!event.target.value);
        }
    });
};

const bindSwitchingCheckEvents = (networkSwitchingForm, networkSwitchingDateSelect) => {
    // const inputs = networkSwitchingForm.querySelector(`[${DATASET}-check-triggers]`).querySelectorAll('input');

    // inputs.forEach((node) => {
    //     node.addEventListener('blur', (e) => {
    //         if (e.target.readOnly) {
    //             return;
    //         }
    //         requestAvailableSwitchingDates(e, networkSwitchingDateSelect);
    //     });
    // });
};

const submitConsent = (event) => {
    const form = event.target.closest(`[${DATASET}]`);
    const formFeedback = form.parentNode.querySelector(`[${DATASET}-feedback]`);
    const loader = document.querySelector('[data-loading-overlay]');

    event.preventDefault();
    loader.dataset.activeTasks = 1;
    formFeedback.setAttribute('hidden', 'hidden');

    requestEndpoint(
        form.getAttribute('data-action'),
        'POST',
        new FormData(cloneForm(form, true))
    )
        .then((data) => {
            if (data.result === 'success') {
                const phoneNumber = form.querySelector(`[${DATASET}-phone-number]`);
                const codeType = form.querySelector(`[${DATASET}-type]`);

                let dateSelected = new Date(data.date.date.replace(/ /g, 'T'));
                let dd = dateSelected.getDate().toString();
                let mm = (dateSelected.getMonth() + 1).toString();
                const yy = dateSelected.getFullYear().toString().substr(-2);

                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                dateSelected = dd + '/' + mm + '/' + yy;

                toggleReadOnly(phoneNumber, true);
                toggleReadOnly(codeType, true);

                form.querySelector(`[${DATASET}-available-dates]`).parentElement.parentElement.classList.add('hidden');
                form.querySelector(`[${DATASET}-confirm]`).classList.add('hidden');
                form.querySelector(`[${DATASET}-message]`).innerHTML = '<span class="brand-erminto-icon check valign-middle margin-right-plus-5px"></span>' + dateSelected + ' has been requested as your switch date.';
                form.querySelector(`[${DATASET}-success]`).classList.remove('hidden');
                setHidden(form.querySelector(`[${DATASET}-success]`), false);
            } else {
                throw new Error(data.message);
            }
        })
        .catch(error => updateFeedback(form, formFeedback, error.message))
        .finally(() => loader.dataset.activeTasks = 0);
};

const resetForm = (e, form) => {
    const phoneNumber = form.querySelector(`[${DATASET}-phone-number]`);
    const codeTypes = form.querySelectorAll(`[${DATASET}-type]`);
    const availableDates = form.querySelector(`[${DATASET}-available-dates]`);
    const confirm = form.querySelector(`[${DATASET}-confirm]`);
    const confirmButton = form.querySelector(`[${DATASET}-button-confirm]`);
    const confirmDateError = form.querySelector('#confirm-btn-error');
    const button = form.querySelector(`[${DATASET}-button]`);
    const successMessageBox = form.querySelector(`[${DATASET}-success]`);
    const failureMessageBox = form.parentNode.querySelector(`[${DATASET}-feedback]`);
    const radioInputs = form.querySelectorAll(`[${DATASET}-decision] input[type="radio"]`);
    const fieldset = form.querySelector(`[${DATASET}-fieldset]`);

    setNetworkSwitchingNotRequired(form);

    clearInputValue(phoneNumber);
    toggleReadOnly(phoneNumber, false);
    toggleDisabledAttr(fieldset, false);

    codeTypes.forEach((codeType) => {
        clearInputValue(codeType);
        clearValidClassAroundInput(codeType);
        toggleReadOnly(codeType, false);
    });

    clearInputValue(availableDates);
    const dateOptions = form.querySelector(`[${DATASET}-available-dates]`).querySelectorAll(':scope option');

    for (const element of dateOptions) {
        element.removeAttribute('selected');
    }
    availableDates.options[0].setAttribute('selected', 'selected');
    availableDates.parentElement.parentElement.classList.add('hidden');

    if (confirmButton) {
        toggleDisabledAttr(confirmButton, false);
    }
    if (confirmDateError) {
        setHidden(confirmDateError, true);
    }
    // toggleDisabledAttr(button, false);
    setHidden(successMessageBox, true);
    setHidden(failureMessageBox, true);

    phoneNumber.dataset.validate = false;
    codeTypes.forEach((codeType) => {
        codeType.dataset.validate = false;
    });
    if (e && e.target && e.target.checked) {
        availableDates.removeAttribute('data-validate')
    } else {
        availableDates.dataset.validate = false;
    }

    radioInputs.forEach((radioInput) => {
        radioInput.checked = false;
    });

    if (form.dataset.networkSwitchingDirty == 1 && e != null) {
        clearSwitchingPreferences(e);
    }
    destroyCalendar();
};

const destroyCalendar = () => {
    if (typeof calendarSwitching != 'undefined' && calendarSwitching != null && Object.getOwnPropertyNames(calendarSwitching).length !== 0) {
        calendarSwitching.remove();
    }
};

const clearSwitchingPreferences = (event) => {
    const form = event.target.closest(`[${DATASET}]`);
    const formFeedback = form.parentNode.querySelector(`[${DATASET}-feedback]`);
    const loader = document.querySelector('[data-loading-overlay]');

    event.preventDefault();
    loader.dataset.activeTasks = 1;
    formFeedback.setAttribute('hidden', 'hidden');

    requestEndpoint(
        form.dataset.networkSwitchingClearEndpoint,
        'POST',
        new FormData(cloneForm(form, false))
    )
        .then((data) => {
            if (data.result === 'success') {
                form.dataset.networkSwitchingDirty = 0;
            } else {
                throw new Error(data.message);
            }
        })
        .catch(error => updateFeedback(form, formFeedback, error.message))
        .finally(() => loader.dataset.activeTasks = 0);
};

const setNetworkSwitchingRequired = (form) => {
    const networkSwitchingToggleHidden = form.querySelector("[data-network-switching-toggle-hidden] input");
    const networkSwitchingDecisions = form.querySelectorAll("[data-network-switching-decision] input");

    networkSwitchingToggleHidden.value = "enabled";
    networkSwitchingDecisions.forEach((networkSwitchingDecision) => {
        networkSwitchingDecision.setAttribute('required', 'required');
    });
};

const setNetworkSwitchingNotRequired = (form) => {
    const networkSwitchingToggleHidden = form.querySelector("[data-network-switching-toggle-hidden] input");
    const networkSwitchingDecisions = form.querySelectorAll("[data-network-switching-decision] input");

    networkSwitchingToggleHidden.value = "";
    networkSwitchingDecisions.forEach((networkSwitchingDecision) => {
        networkSwitchingDecision.removeAttribute('required');
    });
};

const setFormAttributeOnSelectedDates = (form) => {
    const networkSwitchingAvailableDatesSelect = form.querySelector(`[${DATASET}-available-dates]`);
    if (networkSwitchingAvailableDatesSelect.hasAttribute('form')) {
        return;
    }
    //networkSwitchingAvailableDatesSelect.setAttribute('form', 'basket-form');
};

const setToggleOff = (form, e = null) => {
    const networkSwitchingToggleElement = form.querySelector(`[${DATASET}-toggle]`);

    resetForm(e, form);
    const netSwitchingContent = form.querySelector(`[${DATASET}-section]`);
    setHidden(netSwitchingContent, true);
    networkSwitchingToggleElement.checked = false;
}

const addPACSTACInfoIcons = (form) => {
    let pacInfoIcon = document.createElement('i');
    pacInfoIcon.setAttribute('class', 'info-icon');
    pacInfoIcon.setAttribute('data-toggle', 'modal');
    pacInfoIcon.setAttribute('disabled', 'disabled');
    pacInfoIcon.setAttribute('data-target', '[data-modal-id="switch_network_pac_info"]');
    
    if (location.href.includes('mobiles')) {
        pacInfoIcon.setAttribute('role', 'button');
        //This should only apply to mobiles brand only
        form.querySelector('[data-network-switching-type="pac"]').parentNode.querySelector('label').insertAdjacentElement('afterend', pacInfoIcon);
    } else {
        form.querySelector('[data-network-switching-type="pac"]').parentNode.querySelector('label').appendChild(pacInfoIcon);
    }

    let stacInfoIcon = document.createElement('i');
    stacInfoIcon.setAttribute('class', 'info-icon');
    stacInfoIcon.setAttribute('data-toggle', 'modal');
    stacInfoIcon.setAttribute('disabled', 'disabled');
    stacInfoIcon.setAttribute('data-target', '[data-modal-id="switch_network_stac_info"]');
    
    if (location.href.includes('mobiles')) {
        stacInfoIcon.setAttribute('role', 'button');
        form.querySelector('[data-network-switching-type="stac"]').parentNode.querySelector('label').insertAdjacentElement('afterend', stacInfoIcon);
    } else {
        form.querySelector('[data-network-switching-type="stac"]').parentNode.querySelector('label').appendChild(stacInfoIcon);
    }
};

export default checkoutNetworkSwitching;

import datepicker from 'js-datepicker';

function dateNoTime(date) {
    return date.setHours(0, 0, 0, 0);
}

function validateDatepicker(instance) {
    const dateSelected = instance.dateSelected;
    const el = instance.el;
    const parent = instance.parent;
    if (typeof dateSelected == 'undefined' || dateSelected == null) {
        parent.classList.add('has-error');
        el.nextElementSibling.innerHTML = '<ul class="list-unstyled"><li>Please select the date you would like the switch to occur on</li></ul>';
    } else {
        parent.classList.remove('has-error');
        el.nextElementSibling.innerHTML = '';
    }
}

function createCalendar(availableDatesValues) {
    const firstDateAvailable = availableDatesValues[0];
    const lastDateAvailable = availableDatesValues[availableDatesValues.length - 1];

    if (typeof datepickerSwitching != 'undefined' && datepickerSwitching != null) {
        destroyCalendar();

        const availableDatesSelect = document.querySelector('[data-network-switching-available-dates]');
        let disabledDates = [];

        for (let d = new Date(firstDateAvailable); d <= new Date(lastDateAvailable); d.setDate(d.getDate() + 1)) {
            let dateAvailable = false;

            for (var i = 0; i < availableDatesValues.length; i++) {
                let calendarDate = dateNoTime(d);
                let arrayDate = dateNoTime(new Date(availableDatesValues[i]));

                if (calendarDate == arrayDate) {
                    dateAvailable = true;
                    break;
                }
            }
            if (!dateAvailable) {
                disabledDates.push(new Date((d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear()));
            }
        }
        calendarSwitching = datepicker(datepickerSwitching, {
            startDay: 1,
            minDate: new Date(firstDateAvailable),
            maxDate: new Date(lastDateAvailable),
            disableYearOverlay: true,
            disabledDates: disabledDates,
            formatter: (input, date) => {
                const value = date.toLocaleDateString();
                input.value = value;
            },
            onSelect: (instance) => {
                availableDatesSelect.querySelectorAll(':scope option').forEach((element) => {
                    element.removeAttribute('selected');
                });
                availableDatesSelect.querySelector(':scope option[value="' + instance.dateSelected.getFullYear() + '-' + (instance.dateSelected.getMonth() + 1).toString().padStart(2, '0') + '-' + (instance.dateSelected.getDate()).toString().padStart(2, '0') + '"]').setAttribute('selected', 'selected');
                availableDatesSelect.dispatchEvent(new Event('change'));
            },
            onHide: (instance) => {
                validateDatepicker(instance);
            }
        });
        datepickerSwitching.classList.remove('hidden');
        availableDatesSelect.parentNode.classList.add('sr-only');
        availableDatesSelect.parentNode.previousElementSibling.classList.add('sr-only');
    }
}

if (document.querySelector(`.checkout-network-switching[${DATASET}]`) && datepickerSwitching) {
    window.addEventListener('load', () => {
        const dateChoices = datepickerSwitching.getAttribute('data-date-choices');
        const dateChoicesArray = dateChoices.split(',');

        if (dateChoicesArray.length > 1) {
            createCalendar(dateChoicesArray);
        }
    });
}

function resetData(networkSwitchingContainer) {
    const inputs = networkSwitchingContainer.querySelectorAll('input, select');

    inputs.forEach((element) => {
		if (
			element.hasAttribute('data-network-switching-toggle-hidden-input') ||
			element.hasAttribute('data-network-switching-publicId')
		) {
            return;
        }

        let defaultValue = element.hasAttribute('data-default-value') ? element.getAttribute('data-default-value') : '';
        if (element.type === 'checkbox' || element.type === 'radio') {
            element.checked = false;
        } else if (element.tagName === 'SELECT') {
            element.selectedIndex = 0;
        } else {
            element.value = defaultValue ? defaultValue : '';
        }
    });
}
